import { InfiniteData, useQueryClient } from '@tanstack/react-query'

import { Observation, ObservationsResult } from '../../types/observation'
import { Pagination, Results } from '../../types/pagination'

type QueryData = InfiniteData<ObservationsResult> | undefined

export const useObservationsPrepend = () => {
  const queryClient = useQueryClient()

  const prependObservation = async (observation: Observation) => {
    queryClient.setQueriesData<InfiniteData<ObservationsResult>>(
      { queryKey: ['observations'], exact: false },
      (data: QueryData): QueryData => {
        if (data && data.pages.length === 0) {
          // if data is defined but pages array is empty, then we need to populate
          // it with the new observation
          return {
            ...data,
            pages: [makeResult(observation)],
          }
        }

        if (data && data.pages.length > 0) {
          // if data is defined and there are pages, we need to prepend the new
          // observation to the existing page
          const firstPage = data.pages[0]
          const newFirstPage = {
            ...firstPage,
            results: [observation, ...firstPage.results],
          }

          const restPages = data.pages.slice(1)

          return {
            pageParams: data.pageParams,
            pages: [newFirstPage, ...restPages],
          }
        }

        // otherwise data is undefined, then we need to create data object and
        // populate it with the new observation
        return {
          pageParams: [],
          pages: [makeResult(observation)],
        }
      }
    )
  }

  return { prependObservation }
}

const makeResult = <T>(item: T): Pagination & Results<T> => {
  const result = {
    count: 1,
    next: undefined,
    previous: undefined,
    results: [item],
  }
  return result
}
